export default "__VITE_ASSET__x1jUg_JL__"